<template>
  <v-row>
    <v-col cols="auto">
      <v-icon class="mt-2"> mdi-translate </v-icon>
    </v-col>
    <v-col cols="5">
      <v-select v-model="selectedLanguage" dense :items="langs" />
    </v-col>
  </v-row>
</template>

<script>
import {useI18n} from "@/composables/useI18n";

export default {
  name: "locale-changer",
  data() {
    return {
      selectedLanguage: this.$i18n.locale,
      langs: ["de", "en"]
    };
  },
  watch: {
    selectedLanguage: function (value){
      this.$i18n.locale = value;
      const { locale } = useI18n();
      locale.value = value;
    }
  }
};
</script>
